import Factory from './factory';

export default new Factory()
    .addProp('options', Array);
